import React, { useEffect, useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";
import "../styles/AdminMandates.css";

function AdminMandates() {
  const [mandates, setMandates] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => fetchData(), 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = () => {
    fetch("https://kolibusiness.com/backend/get-mandates.php")
      .then(res => res.json())
      .then(data => setMandates(data))
      .catch(err => console.error("Error fetching mandates:", err));
  };

  const filtered = mandates.filter(m =>
    (statusFilter === "ALL" || m.status === statusFilter) &&
    (m.mandate_id.toLowerCase().includes(search.toLowerCase()) ||
      m.phone.includes(search) ||
      m.email.toLowerCase().includes(search.toLowerCase()))
  );

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const paginated = filtered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const exportCSV = () => {
    const header = ["Mandate ID", "Loan No", "Status", "Phone", "Email", "Received At"];
    const rows = filtered.map(r => [r.mandate_id, r.loan_no, r.status, r.phone, r.email, r.received_at]);
    const csvContent = [header, ...rows].map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "mandates.csv";
    a.click();
  };

  if (!hasPermission("mandates", "view")) {
    return (
      <AdminLayout>
        <p style={{ color: "red", padding: "20px", fontWeight: "bold" }}>
          ❌ You do not have permission to view mandates.
        </p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="mandates-header">
        <h2>📋 eMandate Webhook Logs</h2>
        <div className="mandates-controls">
          <input
            type="text"
            placeholder="🔍 Search by phone, email or ID"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
            <option value="ALL">All Status</option>
            <option value="SUCCESS">SUCCESS</option>
            <option value="FAILED">FAILED</option>
            <option value="PENDING">PENDING</option>
          </select>
          {hasPermission("mandates", "edit") && (
            <button onClick={exportCSV}>📤 Export CSV</button>
          )}
        </div>
      </div>

      <table className="mandate-table">
        <thead>
          <tr>
            <th>Mandate ID</th>
            <th>Loan No</th>
            <th>Status</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Received At</th>
          </tr>
        </thead>
        <tbody>
          {paginated.length === 0 ? (
            <tr><td colSpan="6">No matching records found.</td></tr>
          ) : (
            paginated.map((row, i) => (
              <tr key={i}>
                <td>{row.mandate_id}</td>
                <td>{row.loan_no}</td>
                <td>{row.status}</td>
                <td>{row.phone}</td>
                <td>{row.email}</td>
                <td>{row.received_at}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="pagination">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? "active" : ""}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </AdminLayout>
  );
}

export default AdminMandates;
